import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    text: 'Organicé todo el consultorio en una tarde. Los protocolos del Tomo 2 me ahorran 2 horas por semana.',
    author: 'Mariana G., Córdoba',
    role: 'Nutricionista Clínica'
  }, {
    initials: 'LP',
    text: 'Las láminas del Tomo 4 reemplazaron 20 minutos de explicación por consulta. Mis pacientes entienden todo.',
    author: 'Laura P., Rosario',
    role: 'Centro de Nutrición'
  }, {
    initials: 'RM',
    text: 'Cerré mi primer paquete de $35.000 en una sola conversación de WhatsApp usando el guión del Bono 3.',
    author: 'Romina M., Buenos Aires',
    role: 'Especialista Hormonal'
  }];
  return <section className="bg-black text-white py-20 px-4" data-id="element-250">
      <div className="max-w-5xl mx-auto" data-id="element-251">
        <h2 className="font-display font-black text-4xl md:text-5xl text-center mb-12 uppercase" data-id="element-252">
          Lo que dicen quienes <span className="text-brand" data-id="element-253">ya lo usan</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-254">
          {testimonials.map((t, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl flex flex-col h-full hover:border-brand/50 transition-colors" data-id="element-255">
              <div className="flex items-center justify-between mb-6" data-id="element-256">
                <div className="w-12 h-12 bg-brand/20 text-brand rounded-full flex items-center justify-center font-bold text-xl" data-id="element-257">
                  {t.initials}
                </div>
                <div className="flex text-brand" data-id="element-258">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-259" />)}
                </div>
              </div>
              <p className="text-lg italic text-gray-300 mb-6 flex-grow" data-id="element-260">
                "{t.text}"
              </p>
              <div data-id="element-261">
                <div className="font-bold text-white" data-id="element-262">{t.author}</div>
                <div className="text-brand text-sm font-medium" data-id="element-263">{t.role}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}